import { c as i } from "./highrise314.mjs";
import s from "./highrise994.mjs";
const {
  cubicBezierEaseInOut: n
} = s;
function l({
  name: t = "fade-in",
  enterDuration: o = "0.2s",
  leaveDuration: r = "0.2s",
  enterCubicBezier: a = n,
  leaveCubicBezier: e = n
} = {}) {
  return [i(`&.${t}-transition-enter-active`, {
    transition: `all ${o} ${a}!important`
  }), i(`&.${t}-transition-leave-active`, {
    transition: `all ${r} ${e}!important`
  }), i(`&.${t}-transition-enter-from, &.${t}-transition-leave-to`, {
    opacity: 0
  }), i(`&.${t}-transition-leave-from, &.${t}-transition-enter-to`, {
    opacity: 1
  })];
}
export {
  l as fadeInTransition
};
